<script>
import MentionBox from '../mentions/MentionBox.vue';
import CannedResponseAPI from 'dashboard/api/cannedResponse';

// AIVIO patch (2026-06-18): debounce per-keystroke search (2a) + drop out-of-order
// (stale) responses (2b). Fixes laggy / "jumping" canned-response list under load,
// where a slower earlier request could overwrite a newer one. Component-local state
// so the global canned-response store (settings page) stays untouched.
export default {
  components: { MentionBox },
  props: {
    searchKey: {
      type: String,
      default: '',
    },
  },
  emits: ['replace'],
  data() {
    return {
      records: [],
      latestRequestId: 0,
      searchDebounceTimer: null,
    };
  },
  computed: {
    items() {
      return this.records.map(cannedMessage => ({
        label: cannedMessage.short_code,
        key: cannedMessage.short_code,
        description: cannedMessage.content,
      }));
    },
  },
  watch: {
    searchKey() {
      this.debouncedFetch();
    },
  },
  mounted() {
    this.fetchCannedResponses();
  },
  beforeUnmount() {
    if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
  },
  methods: {
    debouncedFetch() {
      if (this.searchDebounceTimer) clearTimeout(this.searchDebounceTimer);
      this.searchDebounceTimer = setTimeout(() => {
        this.fetchCannedResponses();
      }, 250);
    },
    async fetchCannedResponses() {
      const requestId = (this.latestRequestId += 1);
      try {
        const { data } = await CannedResponseAPI.get({ searchKey: this.searchKey });
        if (requestId !== this.latestRequestId) return;
        this.records = Array.isArray(data) ? data : [];
      } catch (error) {
        if (requestId === this.latestRequestId) this.records = [];
      }
    },
    handleMentionClick(item = {}) {
      this.$emit('replace', item.description);
    },
  },
};
</script>

<!-- eslint-disable-next-line vue/no-root-v-if -->
<template>
  <MentionBox
    v-if="items.length"
    :items="items"
    @mention-select="handleMentionClick"
  />
</template>